import React from 'react';
import Alert from 'src/shared/components/ui/alert';
import { PortfolioSpeciesSourceProvider } from 'src/app/portfolio/state/portfolioSpeciesSource';
import PortfolioSiteExplorer from '../portfolio-site-explorer/PortfolioSiteExplorer';

/**
 * The Site Explorer with its species figures read from the prediction grid.
 *
 * The same components as the live page, mounted inside a provider that changes where
 * their species queries point — see portfolioSpeciesSource. Copying the twenty explorer
 * files would leave two versions to keep in step for as long as both exist.
 *
 * Internal only, enforced by route availability rather than here: the banner below
 * says the page is not shown to customers, and a reachable URL would make that untrue.
 */
const NextPortfolioSiteExplorer = () => (
    <PortfolioSpeciesSourceProvider source='grid'>
        <div className='flex flex-col gap-3' data-testid='next-site-explorer'>
            <Alert severity='warning' data-testid='next-site-explorer-internal-only'>
                Internal only — not shown to customers. Species counts come from the global prediction grid, not the portfolio pipeline
                behind the current Site Explorer, so the figures will differ.
            </Alert>
            <PortfolioSiteExplorer />
        </div>
    </PortfolioSpeciesSourceProvider>
);

export default NextPortfolioSiteExplorer;
